import styled from 'styled-components';

export const Wrap = styled.div`
  background: ${({ theme }) => theme.colors.white};
`;

export const BodySection = styled.section`
  padding: 5rem 1.5rem;
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const Lead = styled.div`
  max-width: 780px;

  .eyebrow {
    display: inline-block;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.goldDark};
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gold};
    margin-bottom: 1.5rem;
  }

  h2 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    color: ${({ theme }) => theme.colors.nearBlack};
    margin-bottom: 1.5rem;
    line-height: 1.2;
  }

  p {
    font-size: 1.05rem;
    color: ${({ theme }) => theme.colors.textMuted};
    line-height: 1.85;
  }
`;

export const ServicesSection = styled.section`
  padding: 4rem 1.5rem;
  background: ${({ theme }) => theme.colors.offWhite};
`;

export const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 2rem;
`;

export const ServiceItem = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 1.25rem 1.5rem;
  border-left: 3px solid ${({ theme }) => theme.colors.gold};
  box-shadow: ${({ theme }) => theme.shadows.card};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.nearBlack};

  .idx {
    font-family: ${({ theme }) => theme.fonts.heading};
    color: ${({ theme }) => theme.colors.goldDark};
    font-size: 0.82rem;
    letter-spacing: 0.2em;
    margin-bottom: 0.35rem;
    display: block;
  }
`;

export const Gallery = styled.section`
  padding: 5rem 1.5rem;
`;

export const GalleryGrid = styled.div`
  max-width: 1180px;
  margin: 2rem auto 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
`;

export const GalleryItem = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  &::after {
    content: '';
    position: absolute;
    inset: auto 0 0 0;
    height: 4px;
    background: ${({ theme }) => theme.colors.gold};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s ease;
  }
  &:hover::after { transform: scaleX(1); }
`;

export const Empty = styled.div`
  padding: 4rem 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const LogoWrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1.5rem 0;
  display: flex;
  justify-content: center;

  img {
    max-width: 220px;
    max-height: 140px;
    width: auto;
    height: auto;
    object-fit: contain;
    background: ${({ theme }) => theme.colors.white};
    padding: 1rem 1.5rem;
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.shadows.card};
  }
`;

export const ContactSection = styled.section`
  padding: 4rem 1.5rem;
  background: ${({ theme }) => theme.colors.offWhite};
`;

export const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  margin-top: 2rem;
`;

export const ContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: ${({ theme }) => theme.colors.white};
  border-left: 3px solid ${({ theme }) => theme.colors.gold};
  box-shadow: ${({ theme }) => theme.shadows.card};
  color: ${({ theme }) => theme.colors.nearBlack};
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.base};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
  }

  .icon {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.white};
    flex-shrink: 0;
  }

  .label {
    font-size: 0.72rem;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.textMuted};
    margin-bottom: 0.2rem;
  }

  .value {
    font-weight: 500;
    word-break: break-word;
  }
`;

export const AdditionalInfoSection = styled.section`
  padding: 4rem 1.5rem;

  .content {
    max-width: 900px;
    margin: 2rem auto 0;
    background: ${({ theme }) => theme.colors.white};
    padding: 2rem 2.25rem;
    border-left: 3px solid ${({ theme }) => theme.colors.gold};
    box-shadow: ${({ theme }) => theme.shadows.card};
    color: ${({ theme }) => theme.colors.textMuted};
    line-height: 1.85;
    font-size: 1.02rem;
    white-space: pre-wrap;
  }
`;
